/**
 * Shared constants for the DynamicTable feature.
 * Previously duplicated across CK_Subitem, useLineItems, and ConnectBoardModal.
 */
import type { DropdownOptionT } from './types';

// ─── RGB mapper ───────────────────────────────────────────────────────────────
// Maps CustomColorPicker hex values → {r, g, b} objects for docx header styling.
// Single source of truth — replaces inline duplicates in CK_Subitem/index.jsx,
// LineItems/Hooks/useLineItems.js, and ConnectBoardModal/constants.ts.

export const RGB_MAPPER: Record<string, { r: number; g: number; b: number }> = {
  '#040930': { r: 4,   g: 9,   b: 48  },
  '#396AFF': { r: 57,  g: 106, b: 255 },
  '#0DB691': { r: 13,  g: 182, b: 145 },
  '#FF8282': { r: 255, g: 130, b: 130 },
  '#647E9E': { r: 100, g: 126, b: 158 },
  '#FF2929': { r: 255, g: 41,  b: 41  },
  '#A09C9C': { r: 160, g: 156, b: 156 },
  '#FFC107': { r: 255, g: 193, b: 7   },
  '#93A689': { r: 147, g: 166, b: 137 },
  '#F5F6F8': { r: 245, g: 246, b: 248 },
};

// ─── Filter constants ─────────────────────────────────────────────────────────

export const FILTER_CONDITIONS: DropdownOptionT[] = [
  { label: 'is',           value: 'is'           },
  { label: 'is not',       value: 'is not'       },
  { label: 'is empty',     value: 'is empty'     },
  { label: 'is not empty', value: 'is not empty' },
];

export const FILTER_CHAINING: DropdownOptionT[] = [
  { label: 'And', value: 'AND' },
  { label: 'Or',  value: 'OR'  },
];

/** Conditions that do not require a value input. */
export const EMPTY_CONDITIONS: string[] = ['is empty', 'is not empty'];

// ─── react-select portal styles ───────────────────────────────────────────────
// Passed to monday-ui Dropdown's `extraStyles` prop so menus render above
// any overflow:hidden or z-index container.

export const portalDropdownStyles = () => ({
  menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 10001 }),
  menu: (base: Record<string, unknown>) => ({
    ...base,
    maxHeight: '240px',
    overflow: 'hidden',
  }),
  menuList: (base: Record<string, unknown>) => ({
    ...base,
    maxHeight: '240px',
    overflowY: 'auto',
  }),
});
